import "babel-polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import Antd from "ant-design-vue/lib";
import "ant-design-vue/dist/antd.css";
import "@/assets/css/main.scss";
import remConfig from "@/assets/remConfig.js";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import jsonp from "jsonp";
// import "babel-polyfill";
Vue.prototype.$jsonp = jsonp;
remConfig();
Vue.config.productionTip = false;
Vue.use(VueAwesomeSwiper);
Vue.use(Antd);
new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
